/* eslint-disable prefer-promise-reject-errors */
import _ from 'lodash';

const ERROR_BLACKOUT = 'BLACKOUT_ERROR';
export const isBlackoutError = error => _.get(error, 'internalErrorCode') === ERROR_BLACKOUT;

export const isDmaMatch = (dmas = [], metroCodes = []) => {
  const allAreas = dmas.includes(999);
  const areaMatch = metroCodes.some(metroCode => dmas.includes(metroCode));
  return allAreas || areaMatch || false;
};

export const isTypeMatch = (types = [], isLiveContent) => {
  const lowercaseTypes = _.map(types, type => _.toLower(type));
  const isLive = lowercaseTypes.includes('live') && isLiveContent;
  const isVod = lowercaseTypes.includes('vod') && isLiveContent === false;
  return isVod || isLive || false;
};

export const isChannelMatch = (channels = [], network) => {
  const lowercaseChannels = _.map(channels, channel => _.toLower(channel));
  const allChannels = lowercaseChannels.includes('*');
  const hasNetwork = lowercaseChannels.includes(_.toLower(network));
  return allChannels || hasNetwork || false;
};

export const getBlackoutZones = (opts = {}) => {
  const { cableProviderBlackoutZones = [], metroCodes = [], isLiveContent, network } = opts;
  return cableProviderBlackoutZones.filter((zone = {}) => {
    const { dma, types, channels } = zone;
    // If the "dma" array contains a single value, apply the rule to that single DMA.
    // If the value is 999, apply the rule to all DMAs.
    // If the "dma" array contains multuple entries, selectively apply the rule to each DMA.
    // For backwards compatibility with 1.0, the client must type check for int first.
    let dmaMatches;
    if (_.isInteger(dma)) {
      // v1.0 handling
      dmaMatches = dma === 999 || metroCodes.includes(dma);
    } else if (_.isArray(dma)) {
      // v1.1 handling
      dmaMatches = isDmaMatch(dma, metroCodes);
    }
    const typeMatches = isTypeMatch(types, isLiveContent);
    const channelMatches = isChannelMatch(channels, network);

    if (dmaMatches && typeMatches && channelMatches) return true;
    return false;
  });
};

export async function getContentBlackout(opts = {}) {
  return new Promise(async (resolve, reject) => {
    const {
      blackoutConfig,
      blackoutDefinitions,
      cableProviderId,
      contentRequiresAuth,
      dma,
      deviceId,
      getDesignatedMarketingAreaData,
      isLive: isLiveContent,
      network,
      zipCode,
    } = opts;
    const lowercaseCableProviderId = _.toLower(cableProviderId);
    const enabled = _.get(blackoutConfig, 'enabled');
    const providerBlackoutDefinition = _.get(blackoutDefinitions, lowercaseCableProviderId);
    const noBlackout = !enabled || !providerBlackoutDefinition || !zipCode || !contentRequiresAuth;

    if (noBlackout) return resolve();

    const cableProviderBlackoutZones = _.get(providerBlackoutDefinition, 'zones');
    let designatedMarketingAreaData;

    try {
      designatedMarketingAreaData = await getDesignatedMarketingAreaData({ deviceId, zipCode });
    } catch (e) {
      console.error('DMA Fetch Failed', e);
      resolve();
    }

    const metroCodes = _.map(designatedMarketingAreaData, item =>
      _.toInteger(_.get(item, 'metroCode')),
    );
    if (dma) metroCodes.push(_.toInteger(dma));
    const blackoutZonesOptions = {
      cableProviderBlackoutZones,
      metroCodes,
      isLiveContent,
      network,
    };
    const blackoutZones = getBlackoutZones(blackoutZonesOptions);
    const isBlackout = blackoutZones && blackoutZones.length > 0;

    if (isBlackout) {
      return reject({
        internalErrorCode: ERROR_BLACKOUT,
        contentBlackoutLanguageOverrides: {
          message: _.get(providerBlackoutDefinition, 'message'),
          title: _.get(providerBlackoutDefinition, 'title'),
        },
      });
    }

    return resolve();
  });
}
